import React from "react";
import RightHandSide from "../../Common/Services/RightHandSide";
import AboutInnBanContent from "../../Common/InnerBanner/AboutInnBanContent";
import { AboutInnerBanner } from "../../Common/InnerBanner/AboutInnerBanner";
import HeadContent from "../BlogContent/HeadContent";
import HeadDesign from "../BlogContent/HeadDesign";
import Info from "../BlogContent/Info";
import List from "../BlogContent/List";
import InfoContent from "../BlogContent/InfoContent";
import ListContent from "../BlogContent/ListContent";
import RecentBlogsList from "../BlogContent/RecentBlogsList";
import { Helmet } from "react-helmet";

const Blog43 = () => {
  const { image, heading, pageName } = AboutInnBanContent.BlogDetails;
  const { bg, para, date, blogHeading } = HeadContent.blog_43;

  const { title, p } = InfoContent.Blog_43.one;
  const { title2, p2 } = InfoContent.Blog_43.two;
  const { title3, p3 } = InfoContent.Blog_43.three;
  const { title4, p4 } = InfoContent.Blog_43.four;
  const { title5, p5 } = InfoContent.Blog_43.five;
  const { title6, p6 } = InfoContent.Blog_43.six;
  const { title7, p7 } = InfoContent.Blog_43.seven;
  const { title8, p8 } = InfoContent.Blog_43.eight;
  const { title9, p9 } = InfoContent.Blog_43.nine;

  //   const { Ctitle, Cp } = InfoContent.Blog_43.conclusion;

  const { liss3 } = ListContent.Blog_43.L3;
  const { liss6 } = ListContent.Blog_43.L6;

  return (
    <>
      <Helmet>
        <title>
          When to See a Fertility Specialist in India? 7 Warning Signs
        </title>

        <meta
          name="description"
          content="Struggling to conceive? Learn the 7 red flags that indicate it's time to consult a fertility doctor in India. Don't wait—take control of your parenthood journey."
        />

        <meta
          name="keywords"
          content="when to consult fertility doctor India, fertility specialist near me, IVF success India, ACME fertility clinic"
        />

        <link
          rel="canonical"
          href="https://www.acmefertility.com/43/when-to-see-fertility-specialist-india"
        />

        {/* Article Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id":
                "https://www.acmefertility.com/when-to-see-fertility-specialist-india",
            },
            headline:
              "When to See a Fertility Specialist in India – Red Flags Every Couple Should Know",
            description:
              "Learn the 7 critical red flags that indicate when an Indian couple should consult a fertility doctor, including age factors, PCOS, and male infertility signs.",
            image:
              "https://www.acmefertility.com/images/fertility-specialist-consultation.jpg",
            author: {
              "@type": "Organization",
              name: "ACME Fertility",
            },
            publisher: {
              "@type": "Organization",
              name: "ACME Fertility",
              logo: {
                "@type": "ImageObject",
                url: "https://www.acmefertility.com/logo.png",
              },
            },
            datePublished: "2026-09-10",
            dateModified: "2026-09-10",
            keywords:
              "when to consult fertility doctor India, fertility specialist near me, IVF success India, infertility signs",
            articleSection: "Fertility Awareness",
          })}
        </script>

        {/* Author Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "@id": "https://www.acmefertility.com/#author",
            name: "ACME Fertility",
            url: "https://www.acmefertility.com/",
          })}
        </script>

        {/* FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "When should a couple under 35 see a fertility specialist in India?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Couples under 35 should consult a fertility specialist if they have been trying to conceive through regular unprotected intercourse for one year without success.",
                },
              },
              {
                "@type": "Question",
                name: "Does PCOS affect my chances of getting pregnant?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, PCOS (Polycystic Ovary Syndrome) is a common cause of infertility in Indian women due to irregular ovulation. Seeing a specialist early can help manage the condition and improve conception chances.",
                },
              },
              {
                "@type": "Question",
                name: "Are fertility issues always related to the woman?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "No. In India, approximately 40-50% of infertility cases involve male factors, such as low sperm count or motility. Both partners should be tested simultaneously.",
                },
              },
              {
                "@type": "Question",
                name: "When should I see a fertility doctor if I am over 35?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Women over the age of 35 are advised to seek a fertility consultation after just 6 months of trying, as ovarian reserve tends to decline more quickly after this age.",
                },
              },
            ],
          })}
        </script>
        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "@id":
              "https://www.acmefertility.com/when-to-see-fertility-specialist-india#breadcrumb",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.acmefertility.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Fertility",
                item: "https://www.acmefertility.com/Fertility.php",
              },
              {
                "@type": "ListItem",
                position: 3,
                name: "When to See a Fertility Specialist in India – Red Flags Every Couple Should Know",
                item: "https://www.acmefertility.com/when-to-see-fertility-specialist-india",
              },
            ],
          })}
        </script>
      </Helmet>

      <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

      <div className="blog-area pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <HeadDesign
                bg={bg}
                para={para}
                date={date}
                blogHeading={blogHeading}
              />

              <Info title={title} p={p} />
              <Info title={title2} p={p2} />
              <Info title={title3} p={p3} />
              <List liss={liss3} />
              <Info title={title4} p={p4} />
              <Info title={title5} p={p5} />
              <Info title={title6} p={p6} />
              <List liss={liss6} />
              <Info title={title7} p={p7} />
              <Info title={title8} p={p8} />
              <Info title={title9} p={p9} />
            </div>

            <div className="col-lg-4">
              <RecentBlogsList />
              <RightHandSide />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog43;
